export default __webpack_public_path__ + "static/media/Akshita.b2534021.png";